import React from "react";
import styled from "styled-components";

const Btn = ({ className, img, onClick}) => {

  const handleClick = () => {
    onClick();
  }

  return <Container onClick={handleClick} className={className || ''}>
    <img src={img} alt='' className="btn-img"/>
  </Container>
}

export default React.memo(Btn);

const Container = styled.div`
  position: relative;
  .click-img {
    width: 44.5px;
    height: 43px;
    position: absolute;
    bottom: -30px;
    right: -10px;
  }
  .btn-img {
    width: 100%;
    height: 100%;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/components/btn.js